import * as React from "react";
import Scrollbars from 'react-custom-scrollbars';

interface IOverlayWindowComponentProps {
	title: string;
	isVisible: boolean;
	onClose?: () => void;
	submitText?: string;
	footerElement?: JSX.Element;
}

interface IOverlayWindowComponentState {
	isVisible: boolean;
}

export class OverlayWindowComponent extends React.Component<IOverlayWindowComponentProps, IOverlayWindowComponentState> {
	constructor(props: IOverlayWindowComponentProps) {
		super(props);
		this.onClose = this.onClose.bind(this);
		this.state = { isVisible: false }
	}

	public componentDidUpdate(prevProps: IOverlayWindowComponentProps) {
		if (this.props.isVisible !== prevProps.isVisible) {
			document.body.classList.toggle("no-scroll");
		}
	}

	public render() {
		return (
			this.props.isVisible ?
				<div>
					<div className="overlay-window-layer">
						<div className="overshadow-container">
							<div className="overlay-window">
								<div className="overlay-window-header">
									<div className="overlay-window-close">
										<div className="close-image" onClick={() => this.onClose()}>
										</div>
									</div>
									<div className="overlay-window-title">
										<h4>{this.props.title}</h4>
									</div>
								</div>
								<div className="overlay-window-content">
									{this.props.children}
								</div>
								<div className="overlay-window-footer">
									<div className="overlay-window-footer-actions">
										{this.props.footerElement ?
											this.props.footerElement
											:
											null
										}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			:null
		)
	}

	private onClose() {
		if (this.props.onClose) {
			this.props.onClose();
		}
	}
}

